/* global site_params */
import $ from 'jquery';
import core from '../core';
import {inViewport} from '../helpers';

const scrollbarWidthMin = 5;
const scrollbarWidthMax = 17;
const IOS_FIX_VERSION_NUMBER = 16;
const NEEDS_IOS_FIX = (
    () => {
        let e = /iPhone OS (\d+)/gm.exec(navigator.userAgent),
            t = /like Gecko\) Version\/(\d+)/gm.exec(navigator.userAgent),
            a = !1;
        return e ? a = parseInt(e[1], 10) >= IOS_FIX_VERSION_NUMBER : t &&
            (a = parseInt(t[1], 10) >= IOS_FIX_VERSION_NUMBER),
            a
    }
)();

function detectScrollbars() {
    if (window.innerWidth > document.body.clientWidth + scrollbarWidthMin) {
        document.body.classList.add('has-scrollbar');
        let scrollbarWidth = Math.min(scrollbarWidthMax, window.innerWidth - document.body.clientWidth);
        document.documentElement.style.setProperty('--scrollbar-width', `${ scrollbarWidth }px`)
    } else {
        document.documentElement.style.setProperty('--scrollbar-width', '0px');
        document.body.classList.remove('has-scrollbar');
    }
}

function anchorsSmoothScroll() {
    // Select all links with hashes
    // Select all links with hashes
    $('a[href*="#"]')
        // Remove links that don't actually link to anything
        .not('[href="#"]')
        .not('[href="#0"]')
        .not('.no-smooth-scroll')
        .click(function (event) {
            // On-page links
            if (
                location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
                &&
                location.hostname == this.hostname
            ) {
                // Figure out element to scroll to
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                // Does a scroll target exist?
                if (target.length) {
                    // Only prevent default if animation is actually gonna happen
                    event.preventDefault();

                    // Trigger event to hide menu.
                    $(document.body).trigger('hide_menu');

                    $('html, body').animate({
                        scrollTop: target.offset().top - $('.js-header').height()
                    }, 1000, function() {
                        // Callback after animation
                        // Must change focus!
                        var $target = $(target);
                        $target.focus();

                        if ($target.is(':focus')) { // Checking if the target was focused
                            return false;
                        } else {
                            $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
                            $target.focus(); // Set focus again
                        }
                    });
                }
            }
        });
}

function activeNavScroll() {
    $('.js-active-nav-scroll').on('shown.bs.tab', '[data-bs-toggle="tab"]', (evt) => {
        const id = $(evt.target).data('bs-target');
        const $tab = $(id);

        if ($tab.length && !inViewport($tab, 1)) {
            $('html, body').animate({
                scrollTop: $tab.offset().top - $('.js-header').height()
            }, 1000);
        }
    });
}

function cf7PrivacyPolicyLinks() {
    const privacyPolicyLink = core.config.privacy_policy_link || '';

    $('.wpcf7-form input[name="terms[]"]').each((i, el) => {
        const $label = $(el).closest('label');
        let labelText = $label.find('.wpcf7-list-item-label').text();

        if (privacyPolicyLink) {
            labelText = labelText.replace('Politica de confidențialitate', '<a href="' + privacyPolicyLink + '" target="_blank">Politica de confidențialitate</a>');
        }

        $label.find('.wpcf7-list-item-label').html(labelText);
    });
}

function handleResize() {
    detectScrollbars();
}

function setup() {
    detectScrollbars();
    anchorsSmoothScroll();
    activeNavScroll();
    cf7PrivacyPolicyLinks();
}

core.Component('global', {
    methods: {
        // _raf: Global.prototype.raf,
        _resize: handleResize,
    }
});

core.Ready(setup);
